import { render, staticRenderFns } from "./BenjaminApp.vue?vue&type=template&id=901ec0d8&lang=pug&"
import script from "./BenjaminApp.vue?vue&type=script&lang=js&"
export * from "./BenjaminApp.vue?vue&type=script&lang=js&"
import style0 from "./BenjaminApp.vue?vue&type=style&index=0&id=901ec0d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports